import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32502520"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "organization-sider" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "title-name" }
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "title-text-value"
}

import {
  ref, computed, watch, withDefaults, reactive,
} from 'vue';
import { useStore, } from 'vuex';
import { useRouter, useRoute, } from 'vue-router';
import {
  Tree, Input, Dropdown, Menu,
} from 'ant-design-vue';
import { DownOutlined, } from '@ant-design/icons-vue';

// 左侧树形结构标题-数据统计
interface listType {
  id: string,
  compony: string,
  children? : Array<any>,
  [propertys: string]: any,
}

interface FormState {
  name: string;
  level: string;
}

interface Props {
  pageType: string,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    pageType: { default: '' }
  },
  emits: ['getKey',],
  setup(__props: any, { emit: emits }) {

const props = __props as { pageType: string }

const store = useStore();

const { Item, } = Menu;



const search = reactive<FormState>({
  name: '',
  level: '',
});

// 获取组织架构
store.dispatch('userCenter/getOriFramework');

const dealChildren = (data: listType): Array<any> => {
  const temp: Array<any> = [];

  data.forEach((item: any) => {
    temp.push(item.children ?
      {
        key: item.id,
        title: item.company,
        ...item,
        children: dealChildren(item.children),
      } :
      {
        key: item.id,
        title: item.company,
        ...item,
      });
  });

  return temp;
};

const dealFlat = (data: listType, parent: any = []): Array<any> => {
  const temp: Array<any> = [];

  data.forEach((item: any) => {
    temp.push({
      key: item.id,
      value: item.company,
      level: item.level,
      parent: [item.parentCompany, ...parent,],
    });

    if (item.children) {
      temp.push(dealFlat(item.children, [item.parentCompany, ...parent,]));
    }
  });

  return temp;
};

// 组织架构
const list = ref<any>([]);
// 搜索下拉所有内容
const searchList = ref<any>([]);
// 搜索下来搜索的内容
const menuList = ref<any>([]);

const oriFramework = computed(() => store.state.userCenter.origanizationFramework);

watch(oriFramework, (val) => {
  list.value = dealChildren(val);
  searchList.value = dealFlat(val).flat(Infinity);
});

// 选中的节点
const selectedKeys = ref<any[]>([]);
// 展开节点
const expandData = ref<any[]>([]);



const handleEmit = (keys:any, level:any):void => {
  emits('getKey', {
    selectedKey: keys,
    level,
  });
};
const handleSelect = (s: string[],e: any):void => {
  const { node, } = e;
  const { dataRef: { level, }, } = node;

  handleEmit(selectedKeys.value, level);
};

/**
 * 点击搜索框触发
 * @method onFocus
 * @return {void}
 */
const onFocus = ():void => {
  menuList.value = searchList.value;
};

/**
 * 输入内容触发
 * @method onChange
 * @return {void}
 */
const onChange = ():void => {
  const str = [
    '',
    ...search.name,
    '',
  ].join('.*');
  const regExp = new RegExp(str);

  menuList.value = searchList.value.filter((item: any) => regExp.test(item.value));
};

/**
 * 选择搜索框内容
 * @method onClick
 * @param {any} item 选中的内容
 * @return {void}
 */
const onClick = (item: any):void => {
  search.name = item.value;
  search.level = item.level;
  selectedKeys.value = [item.key,];
  expandData.value = item.parent;
  handleEmit(selectedKeys.value, search.level);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.pageType === 'organization')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "组织架构"))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(Dropdown), null, {
              overlay: _withCtx(() => [
                _createVNode(_unref(Menu), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item) => {
                      return (_openBlock(), _createBlock(_unref(Item), {
                        key: item.key,
                        onClick: ($event: any) => (onClick(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(Input), {
                  value: _unref(search).name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).name) = $event)),
                  placeholder: "输入查询组织",
                  onFocus: onFocus,
                  onChange: onChange
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Tree), {
        "tree-data": list.value,
        selectedKeys: selectedKeys.value,
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
        expandedKeys: expandData.value,
        "onUpdate:expandedKeys": _cache[2] || (_cache[2] = ($event: any) => ((expandData).value = $event)),
        onSelect: handleSelect
      }, {
        title: _withCtx(({title,count}) => [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("span", {
              class: "title-text-name",
              title: title
            }, _toDisplayString(title), 9, _hoisted_7),
            (props.pageType !== 'organization')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(" + _toDisplayString(count) + ")", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["tree-data", "selectedKeys", "expandedKeys"])
    ])
  ]))
}
}

})